<template>
  <div v-if="showPopup" class="popup-overlay">
    <div class="popup card">
        <div class="flex items-center justify-between">
          <p class="p-2 font-semibold text-base" v-if="formattedRemainingTime === 'Session Expired'">Time Out!!</p>
          <p class="font-semibold text-sm" v-else>Your Session is Expiring Soon!!</p>
          <!-- <button class="float-right text-3xl m-2" @click="onCrossBtn()" :hidden="formattedRemainingTime === 'Session Expired'" >
              <img  src="@/assets/cancel.svg" class="h-5 w-5 cursor-pointer"  />
          </button> -->
        </div>
      <div class="border-b border-solid border-lightgrey mt-2"></div>
      <div class="flex pt-3 gap-5">
        <div class="mainSession">
            <img src="@/assets/sessionTimerGradient.svg" class="sessionTimer"/>
          <span>{{ formattedRemainingTime }}</span>
        </div>
        <div class="contentOfSession flex flex-col justify-center">
          <div class="sessionText">
            <p>
              Click
            <span class="font-semibold text-black textSize px-1">"Extend Session"</span>
            to keep working.
            </p>
            <p>Click<span class="font-semibold text-black textSize px-1">"Logout"</span>
            to end your session now.</p>
          </div>
          <div class="flex buttonStyling">
            <div class="flex items-end">
              <button
                type="button"
                class="extendSessionButton filterButton widthForLogout"
                @click="logout"
              >
                Logout Now
              </button>
            </div>
            <div class="flex items-end ">
              <button
                type="button"
                class="filterButton buttonposition"
                v-if="formattedRemainingTime != 'Session Expired'"
                @click="extendSession"
              >
                Extend Session
              </button>
            </div>
          </div>
        </div>
          <div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <style scoped>
    .popup-overlay {
      pointer-events: auto;
    }
    .buttonStyling{
    display: flex;
  flex-direction: row;
  gap: 12px; /* or whatever spacing you want */
  flex-wrap: nowrap;
  align-items: flex-end;
  padding-top: 24px;
  /* height: 13vh; */
  }
  .contentOfSession{
     display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 16px; /* Controls vertical spacing between child elements */
  }
  .widthForLogout{
    width:124px;
    padding-left: 0px;
    padding-right: 0px;
  }
  .buttonposition{
    background-color:var(--color-primary);
    border: 1px solid var(--color-primary);
    cursor: pointer;
    color:white;
    width: 124px;
    padding-left: 0px;
    padding-right: 0px;
  }
  .buttonposition:hover{
      box-shadow: 1px 1px 4px 4px rgba(25, 118, 210, 0.2);
    
  }
  .card {
    width:480px;
    height:250px;
    background-color: #ffffff;
    padding-top: 20px;
    padding-left:20px;
    padding-right:20px;
    border-radius: 8px;
  }
  /* .container{
    background-color: #b37171;
    border-radius: 50%;
  }
  .progress-container{
    align-items: center;
    background-color: #119BB9;
    justify-items: center;
  } */
  .timeRemaining{
    color:var(--color-primary) ;
  }
  .progress-container {
    text-align: center; /* Ensure the text is centered inside */
    font-size: 16px; /* Adjust font size */
  }

  .textSize{
    font-size:12px;
    margin-top: 18px;
    line-height: 20px;
  }
  img,video{
    max-width:none;
    width:140px;
  }
  .extendSessionButton{
    background-color: #ffffff;
    border: 1px solid var(--color-primary);
    color: var(--color-primary);
    cursor: pointer;
  }
  .extendSessionButton:hover {
      background-color: var(--color-primary);
      border: 1px solid var(--color-primary);
      color: #ffffff;
  }
  .extendSessionButton:disabled:hover{
    background-color: #ffffff; /* Ensure no hover effect when disabled */
    border: 1px solid var(--color-primary);
    color: var(--color-primary);
    opacity:0.5;
  }
.mainSession {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
}
.mainSession span {
  position: absolute;
  top:56%;
  left: 50%;
  transform: translate(-50%, -50%);
  color:black;
  font-size: 22px;
  /* font-family: 'Open Sans'; */
  font-weight: 600
  }
  .sessionText{
    padding-top: 24px;
    font-size: 14px;
    /* font-family: open-sans !important; */
  }
  </style>
  
  <script lang="ts">
  import { emitter ,toast} from '@/main';
  import { defineComponent } from 'vue';
  import { mapGetters } from 'vuex';
  
  export default defineComponent({
    data():any {
      return {
        sessionTimeout: 10, // minutes
        warningTime: Number(process.env.VUE_APP_WARNING_TIME) || 1, // minutes
        showPopup: false,
        timer: null,
        time:null,
        warningTimer: null,
        isSessionVisible:true,
        formattedRemainingTime:'',
        isVisible:false

      };
    },
    mounted() {
      emitter.off('showPopup');
      emitter.on('showPopup',(data:any)=>{
          this.showPopup = data;
          this.isVisible = data;
          emitter.emit('isvisible',this.isVisible)
          
      })
      this.getAllTenants();
      this.startSessionTimer();
      
      emitter.off('updateFormattedRemainingTime');
      emitter.on('updateFormattedRemainingTime',(data:any)=>{
        if(data=='Session Expired'){
          this.showPopup=false;
          this.isVisible = false;
          emitter.emit('isvisible',this.isVisible);
          this.logout();
        }       
        this.formattedRemainingTime = data;
        
      })
  
    },
        computed: {
          ...mapGetters({ userInfo: 'userInfo',tenantsInfo:'tenantsInfo'  }),
      },
    methods: {
  
      async getAllTenants() {
  
              // this.$http.get(`${process.env.VUE_APP_AUTH_API}/tenants/getAll`).then((res: any) => {
              //     this.allTenants = res.data;
              this.tenantsInfo.filter((tenant:any) => {
              let userDomain = this.userInfo.email.substring(this.userInfo.email.lastIndexOf("@") + 1);
              let  userOrgDetails = userDomain.split('.')[0];
  
              if( userOrgDetails.toLowerCase()==tenant.tenantName.toLowerCase()){
                  this.sessionTimeout= tenant.sessionTime/60
              }
                      
                  });
              // });
          },
          startSessionTimer() {
    if (this.timer) clearTimeout(this.timer);
    if (this.warningTimer) clearTimeout(this.warningTimer);

    const sessionTimeoutSec = Number(this.sessionTimeout) * 60;
    const warningTimeSec = Number(this.warningTime) * 60;
    const currentTime = Math.floor(Date.now() / 1000);
    const expiresTime = Number(this.userInfo?.expires);
    const remainingTime = Number.isFinite(expiresTime) ? expiresTime - currentTime : null;

    this.showPopup = false;
    this.isVisible = false;
    emitter.emit("isvisible", false);

    if (remainingTime !== null && remainingTime > 0 && remainingTime <= warningTimeSec) {
      this.showPopup = true;
      this.isVisible = true;
      emitter.emit("isvisible", true);
      emitter.emit("sessionPopupVisible", true);
      return;
    }

    if (remainingTime !== null && remainingTime > warningTimeSec) {
      this.warningTimer = setTimeout(() => {
        this.showPopup = true;
        this.isVisible = true;
        emitter.emit("isvisible", true);
      }, (remainingTime - warningTimeSec) * 1000);
    }

    if (sessionTimeoutSec > 0) {
      this.timer = setTimeout(() => {
        // this.handleSessionTimeout();
      }, sessionTimeoutSec * 1000);
    }
  }
  ,
      extendSession() {
            this.$http.get(`${process.env.VUE_APP_AUTH_API}/authentication/extend-session`).then((res: any) => {
            if (this.timer) clearTimeout(this.timer); 
            this.startSessionTimer();
            this.showPopup = false;
            this.isVisible = false;
            emitter.emit('isvisible',this.isVisible);
            emitter.emit('session-extended', res.data.newExpiryTime);
          })
          .catch((error:any) => console.error('Error extending session:', error));
      },
      // onCrossBtn(){
      //   this.isSessionVisible = false;
      //   this.isVisible = false;
      //   emitter.emit('isvisible',this.isVisible);
      // },
      async logout() {
            var payload = {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('AUTH_ID')
                }
            };
            await this.$http
                .post(`${process.env.VUE_APP_AUTH_API}/logout`, payload)
                .then((response: any) => {
                    if (response.status == 200) {
                        toast.success(`Logout Successfully`, {
                            timeout: 1000,
                            closeOnClick: true,
                            closeButton: 'button',
                            icon: true
                        });
                    }
                })
                .catch((error: any) => {
                    toast.error(`Save failed with ${error}`, {
                        timeout: 1000,
                        closeOnClick: true,
                        closeButton: 'button',
                        icon: true
                    });
                });
 
            localStorage.removeItem('AUTH_ID');
            window.location.replace(`${process.env.VUE_APP_AUTH_UI}/logout?returnTo=${process.env.VUE_APP_PLANNER_UI}`);
        }
    },
    beforeUnmount() {
      if (this.timer) clearTimeout(this.timer);
      if (this.warningTimer) clearTimeout(this.warningTimer);
      emitter.off('updateFormattedRemainingTime');
    },
  
  });
  </script>
  
  